import React, { createContext, useContext, useState } from 'react';

// Create a context for profile criteria
const ProfileCriteriaContext = createContext();

// Custom hook to use the ProfileCriteriaContext
export const useProfileCriteria = () => useContext(ProfileCriteriaContext);

// Provider component
export const ProfileCriteriaProvider = ({ children }) => {
  const [profileCriteria, setProfileCriteria] = useState(null);

  return (
    <ProfileCriteriaContext.Provider
      value={{ profileCriteria, setProfileCriteria }}
    >
      {children}
    </ProfileCriteriaContext.Provider>
  );
};
